import React from "react";

const Tested = ({
  width = "22px",
  height = "22px",
  currentColor = "currentColor",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="22" height="22" rx="8" fill={currentColor} />
    <rect x="2" y="2" width="18" height="18" rx="6" fill="white" />
    <rect x="3" y="3" width="16" height="16" rx="5" fill={currentColor} />
    <path
      d="M5 10L6.51788 13.0358C6.70825 13.4165 7.25698 13.4004 7.42467 13.0091L9.57533 7.99089C9.74302 7.59963 10.2917 7.5835 10.4821 7.96424L13.4602 13.9203C13.6594 14.3188 14.2409 14.2774 14.3817 13.8548L15.6183 10.1452C15.7591 9.72257 16.3406 9.68124 16.5398 10.0797L17.5 12"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Tested;
